import { createFileRoute } from '@tanstack/react-router';

import { queryKeys } from '@constants/queryKeys.constant';
import { interventionTaskTypeOptions } from '@constants/tasks.constant';
import { ETaskLevel } from '@enums/task.enum';
import { TaskCreateForm } from '@routes/_layout.(private)/tasks/@components/CreateForm';

export const Route = createFileRoute(
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/tasks/create',
)({
  component: InterventionTasksCreate,
});

function InterventionTasksCreate() {
  const { id: serviceRequestId, interventionId } = Route.useParams();

  return (
    <TaskCreateForm
      level={ETaskLevel.Intervention}
      parentId={interventionId}
      queryKeyToToggle={queryKeys.serviceRequests.interventions(
        serviceRequestId,
      )}
      serviceRequestId={serviceRequestId}
      typeOptions={interventionTaskTypeOptions}
    />
  );
}
